const types = {
  //Get Template name
  GET_QUALITY_MANAGMENT_START: "GET_QUALITY_MANAGMENT_START",
  GET_QUALITY_MANAGMENT_SUCCESS: "GET_QUALITY_MANAGMENT_SUCCESS",
  GET_QUALITY_MANAGMENT_ERROR: "GET_QUALITY_MANAGMENT_ERROR",
  GET_QUALITY_MANAGMENT_RESET: "GET_QUALITY_MANAGMENT_RESET",

  //Create Template name
  CREATE_QUALITY_MANAGMENT_START: "CREATE_QUALITY_MANAGMENT_START",
  CREATE_QUALITY_MANAGMENT_SUCCESS: "CREATE_QUALITY_MANAGMENT_SUCCESS",
  CREATE_QUALITY_MANAGMENT_ERROR: "CREATE_QUALITY_MANAGMENT_ERROR",
  CREATE_QUALITY_MANAGMENT_RESET: "CREATE_QUALITY_MANAGMENT_RESET",

  //delete Template name
  DELETE_QUALITY_MANAGMENT_START: "DELETE_QUALITY_MANAGMENT_START",
  DELETE_QUALITY_MANAGMENT_SUCCESS: "DELETE_QUALITY_MANAGMENT_SUCCESS",
  DELETE_QUALITY_MANAGMENT_ERROR: "DELETE_QUALITY_MANAGMENT_ERROR",
  DELETE_QUALITY_MANAGMENT_RESET: "DELETE_QUALITY_MANAGMENT_RESET",

  //update Template name
  UPDATE_QUALITY_MANAGMENT_START: "UPDATE_QUALITY_MANAGMENT_START",
  UPDATE_QUALITY_MANAGMENT_SUCCESS: "UPDATE_QUALITY_MANAGMENT_SUCCESS",
  UPDATE_QUALITY_MANAGMENT_ERROR: "UPDATE_QUALITY_MANAGMENT_ERROR",
  UPDATE_QUALITY_MANAGMENT_RESET: "UPDATE_QUALITY_MANAGMENT_RESET",

  //single item  name
  SINGLE_QUALITY_MANAGMENT_START: "SINGLE_QUALITY_MANAGMENT_START",
  SINGLE_QUALITY_MANAGMENT_SUCCESS: "SINGLE_QUALITY_MANAGMENT_SUCCESS",
  SINGLE_QUALITY_MANAGMENT_ERROR: "SINGLE_QUALITY_MANAGMENT_ERROR",
  SINGLE_QUALITY_MANAGMENT_RESET: "SINGLE_QUALITY_MANAGMENT_RESET",
};

export default types;
